import React from 'react'
// import logoArt3f from '../../../assets/logoArt3f.png'
import './Partenaires.css'
import logoBottinMondain from '../../../assets/logoBotin-Mondain.png'

const Partenaires = () => {
    return (
        <div className="container">

            <h2 className='h2 text-center'>Decouvrez Nos Partenaires</h2>

            <div className="flexPartenaires">

                {/* <div class="containerX">
                    <div className="image" style={{backgroundImage: `url(${logoArt3f})`, height: 520+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }}/>
                    <div class="overlay">Art3f salon international d'art contemporain</div>
                </div> */}
                <div class="containerX">
                    <div className="image" style={{backgroundImage: `url(${logoBottinMondain})`, height: 520+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}/>
                    <div class="overlay">
                        Bottin Modain 
                        <br/>
                        <a href="https://www.bottin-mondain.fr/" className='text-white '>www.bottin-mondain.fr/</a>
                        
                    </div>
                </div>
                

            </div>  
           

        </div>
    )
}

export default Partenaires


